/**
 * Validates that a constructed URL belongs to the expected trusted base URL origin.
 * Prevents open-redirect / SSRF by ensuring user-controlled path segments
 * cannot redirect the request to an untrusted host.
 */
export function assertTrustedUrl(url: string, baseUrl: string): string {
  const parsed = new URL(url);
  const base = new URL(baseUrl);

  if (parsed.origin !== base.origin) {
    throw new Error('URL does not belong to the trusted API origin.');
  }

  return url;
}
